<div class="tree-input-wrapper">
  <input class="tree-input"
    #treeInput
    (focus)='showTree = true'
    (blur)='onBlurInput($event)'
    [(ngModel)]="mainFilterValue"
    (ngModelChange)="onChangeFilter()"
    [value]="getDisplayValue()"
         title="{{ this.getDisplayValue() }}"
    [ngStyle]="{'width': getInputWidth()}"
         spellcheck="false"
         autocomplete="off">
</div>

<div #treeWrapper class="tree-wrapper" *ngIf="showTree">
  <mat-tree [dataSource]="filteredDataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle
      [ngClass]="{'company': node.organizationType.id === 1, 'site': node.organizationType.id === 2}"
      (click)="onSelectNode(node)" [tabindex]='0'>
      <mat-icon>{{ getIcon(node) }}</mat-icon>
      {{ node.name }}
    </mat-tree-node>

    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
      [ngClass]="{'company': node.organizationType.id === 1, 'site': node.organizationType.id === 2}"
      (click)="onSelectNode(node)" [tabindex]='0'>
      <div class="mat-tree-node">
        <button mat-icon-button matTreeNodeToggle
          [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="sup-icon">{{ getIcon(node) }}</mat-icon>
          <mat-icon class="sub-icon">{{ treeControl.isExpanded(node) ? 'remove_circle' : 'add_circle' }}</mat-icon>
        </button>
        {{ node.name }}
      </div>
      <div [class.tree-invisible]="!treeControl.isExpanded(node)"
        role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>

  <div class="bottom-bar">
    <button (click)="treeControl.expandAll()">
      <mat-icon>expand_more</mat-icon>
    </button>
    <button (click)="treeControl.collapseAll()">
      <mat-icon>expand_less</mat-icon>
    </button>
    <span class="spacer"></span>
    <input id="secondaryFilter" class="search-icon-placeholder"
           placeholder="&#xF002;"
      (blur)='onBlurInput($event)'
      [(ngModel)]="secondaryFilterValue"
      (ngModelChange)="onChangeFilter()"
           spellcheck="false"
           autocomplete="off">
  </div>

</div>
